import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { getTheme } from '../../global/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/pro-solid-svg-icons'

const NavAction = styled.div`
  font-size: ${getTheme('fontSize', 'note')};
  display: flex;
  align-items: center;
  margin-left: auto;
  padding-right: ${getTheme('spacer', 'm')};

  .user-item__icon {
    margin-right: ${getTheme('spacer', 'xs')};
    color: ${getTheme('textColor', 'disabled')};
  }

  a {
    text-decoration: none;
  }
`

class UserNav extends Component {
  render() {
    return (
      <NavAction>
        <div className="user-item__icon">
          <FontAwesomeIcon icon={faSignOut} />
        </div>
        <Link to="/logout">Log out</Link>
      </NavAction>
    )
  }
}

export default UserNav



// WEBPACK FOOTER //
// ./src/components/navs/UserNav.js